import { render } from "./App.vue?vue&type=template&id=6f121452&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6f121452&scoped=true&lang=css"

import exportComponent from "/Users/sphotos/GitHub/pios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f121452"]])

export default __exports__